// @ts-nocheck
import React, { useState, useEffect } from "react";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import { Stripe } from "../../common/Payment/DashBoardStripe";
import style from "./Dashboard.module.scss";
import PropTypes from "prop-types";
import { PageLoader } from "../../common/Loaders/PageLoader";
import { InfoCard } from "../../common/Payment/InfoCard";
import { DashBoardCurrentPlan } from "../../common/Payment/DashBoardCurrentPlan";
import { PaymentCard } from "../../common/Payment/PaymentCard";
import { PaymentHistory } from "../../common/Payment/PaymentHistory";
import { Modal } from "react-bootstrap";
import { SecondaryBtn } from "../../common/Payment/SecondaryBtn";
import { InfoBtn } from "../../common/Payment/InfoBtn";
import { getImageUrl } from "../../../commons/assets_path";
import { useTranslation } from "react-i18next";
import RegistCard from "./RegistCard";

export const DashboardView = ({ client, members_count, client_id, is_internal, locale, country_code }) => {
  const { t } = useTranslation();
  const [id, setId] = useState("");
  const [card, setCard] = useState("");
  const [payments, setPayments] = useState([]);
  const [nextPayment, setNextPayment] = useState({});
  const [currentPlan, setCurrentPlan] = useState();
  const [billing, setBilling] = useState();
  const [isCardDeletable, setCardDeletable] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [inProgress, setInProgress] = useState(true);
  const [errMessage, setErrMessage] = useState("");
  const [paymanetMethodErrMessage, setPaymanetMethodErrMessage] = useState("");
  const [isDone, setIsDone] = useState(false);
  const [isPlanCancelDone, setIsPlanCancelDone] = useState(false);
  const [isLicenseCancelDone, setIsLicenseCancelDone] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => {
    setPaymanetMethodErrMessage("");
    setIsUpdate(false);
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };
  const [paymentOption, setPaymentOption] = useState("credit_card");
  const [currentPaymentMethod, setCurrentPaymentMethod] = useState("credit_card");
  const [licenseDowngradeInfo, setLicenseDowngradeInfo] = useState({});
  const [planDowngradeInfo, setPlanDowngradeInfo] = useState({});

  const getPayments = async () => {
    await axios
      .get(`/${client}/api_payments`, {
        params: {
          limit: 5,
        },
      })
      .then((res) => {
        setPayments(res.data);
      })
      .catch((_) => {
        return;
      });
  };

  const getNextPayment = async () => {
    await axios
      .get(`/${client}/api_payments/next_payment`)
      .then((res) => {
        setNextPayment(res.data);
      })
      .catch((_) => {
        return;
      });
  };

  const getCurrentPlan = async () => {
    await axios
      .get(`/${client}/settings/client_plan_log/current_period_plan`)
      .then((res) => {
        setCurrentPlan(res.data);
        setPaymentOption(res.data.payment_method ? res.data.payment_method : "credit_card");
        setCurrentPaymentMethod(res.data.payment_method);
      })
      .catch((_) => {
        return;
      });
  };

  const registerCard = async (token) => {
    await axios
      .post(`/${client}/api_cards`, {
        token_id: token,
        default: true,
      })
      .then((res) => {
        // 登録したクレジットカードで決済テストを実行して３Dスキャンを実施する
        requestThreeDSecure(res.data.stripe_card_id, res.data.stripe_customer_id);
        setIsDelete(false);
        setErrMessage("");
        setPaymanetMethodErrMessage("");
        getCard();
      })
      .catch((_) => {
        setPaymanetMethodErrMessage(t("DashboardView.クレジットカードの登録に失敗しました。"));
        setIsLoading(false);
        return;
      });
  };

  const updateCard = async (token) => {
    await axios
      .post(`/${client}/api_cards`, {
        token_id: token,
        default: false,
      })
      .then((res) => {
        // 登録したクレジットカードで決済テストを実行して３Dスキャンを実施する
        requestThreeDSecure(res.data.stripe_card_id, res.data.stripe_customer_id);
        setErrMessage("");
        setPaymanetMethodErrMessage("");
        getCard();
      })
      .catch((_) => {
        setPaymanetMethodErrMessage(t("DashboardView.クレジットカードの更新に失敗しました。"));
        setIsLoading(false);
        return;
      });
  };

  const deleteCard = async () => {
    setIsDelete(true);
    await axios
      .delete(`/${client}/api_cards/${id}`)
      .then((res) => {
        setId("");
        setCard("");
        setErrMessage("");
      })
      .catch((error) => {
        setIsDelete(false);
        setErrMessage(error.response.data.message);
        return;
      });
  };

  const requestThreeDSecure = async (stripe_card_id, stripe_customer_id) => {
    await axios
      .post(`/${client}/api_cards/request_three_d_secure`, {
        current_url: window.location.href,
        stripe_card_id: stripe_card_id,
        stripe_customer_id: stripe_customer_id,
        payment_method: paymentOption,
        period_type: currentPlan.period_type,
        code: currentPlan.plan_code,
      })
      .then((res) => {
        if (res.data.redirect_to_url !== "") {
          // 3Dスキャンの実行ページを表示する。
          window.location.href = res.data.redirect_to_url;
        }
      })
      .catch((_) => {
        // setPaymanetMethodErrMessage("3Dスキャンに失敗しました。");
        setIsLoading(false);
        return;
      });
  };

  const changeCard = () => {
    setIsUpdate(true);
  };

  const getCard = async () => {
    await axios
      .get(`/${client}/api_cards/default_card`, {
        params: {
          default_only: true,
        },
      })
      .then((res) => {
        if (!res.data.id) {
          return;
        } else {
          setId(res.data.id);
          setCard(res.data);
          setCardDeletable(res.data.card_deletable);
          setErrMessage("");
        }
      })
      .catch((_) => {
        return;
      });
  };

  const getBillings = async () => {
    await axios
      .get(`/${client}/settings/billing/retrieve`)
      .then((res) => {
        setBilling(res.data);
      })
      .catch((_) => {
        return;
      });
  };

  const updatePaymentMethod = async () => {
    setIsLoading(true);
    await axios
      .patch(`/clients/${client_id}/update_payment_method`, {
        client: {
          payment_method: paymentOption,
        },
      })
      .then(() => {
        setCurrentPaymentMethod(paymentOption);
        setIsLoading(false);
        setIsDone(true);
        handleClose();
      })
      .catch((_) => {
        setIsLoading(false);
        return;
      });
  };

  const fetchLicenseDowngradeInfo = async () => {
    await axios
      .get(`/${client}/settings/client_license_logs/scheduled_downgrade`)
      .then((res) => {
        setLicenseDowngradeInfo(res.data);
      })
      .catch((_) => {
        return;
      });
  };
  const cancelLicenseDowngrade = async () => {
    await axios
      .post(`/${client}/settings/client_license_logs/cancel_downgrade`)
      .then((res) => {
        fetchLicenseDowngradeInfo();
        setIsLicenseCancelDone(true);
      })
      .catch(({ response }) => {
        setErrMessage(response.data.message);
        return;
      });
  };
  const fetchPlanDowngradeInfo = async () => {
    await axios
      .get(`/${client}/settings/client_plan_log/scheduled_downgrade`)
      .then((res) => {
        setPlanDowngradeInfo(res.data);
      })
      .catch((_) => {
        return;
      });
  };

  const cancelPlanDowngrade = async () => {
    await axios
      .post(`/${client}/settings/client_plan_log/cancel_downgrade`)
      .then((res) => {
        fetchPlanDowngradeInfo();
        setIsPlanCancelDone(true);
      })
      .catch(({ response }) => {
        setErrMessage(response.data.message);
        return;
      });
  };

  const initConnect = async () => {
    await getCard();
    await getPayments();
    await getNextPayment();
    await getBillings();
    await getCurrentPlan();
    await fetchLicenseDowngradeInfo();
    await fetchPlanDowngradeInfo();
    setInProgress(false);
  };

  useEffect(() => {
    initConnect();
  }, []);

  return (
    <div className="d-flex justify-content-center">
      <div className="d-flex justify-content-center">
        {!inProgress ? (
          <div data-testid="test-plan-dashboard">
            {Object.keys(licenseDowngradeInfo).length ? (
              <div className={style.downgradeInfoWrap}>
                <div className={style.downgradeInfoDate}>{licenseDowngradeInfo.apply_date}</div>
                <div className={style.downgradeInfoTitle}>{t("DashboardView.ライセンスの削除申し込み")}</div>
                <div className={style.downgradeInfoCount}>
                  {licenseDowngradeInfo.current_license_count} → {licenseDowngradeInfo.next_license_count}
                </div>
                <div
                  className={style.downgradeInfoCancel}
                  data-testid="test-cancel-license"
                  onClick={() => {
                    if (window.confirm(t("DashboardView.本当に取り消ししますか？"))) {
                      cancelLicenseDowngrade();
                    }
                  }}
                >
                  {t("DashboardView.取り消し")}
                </div>
              </div>
            ) : (
              <></>
            )}
            {Object.keys(planDowngradeInfo).length ? (
              <div className={style.downgradeInfoWrap}>
                <div className={style.downgradeInfoDate}>{planDowngradeInfo.apply_date}</div>
                <div className={style.downgradeInfoTitle}>{t("DashboardView.プランの変更予約")}</div>
                <div className={style.downgradeInfoCount} style={{ whiteSpace: "nowrap" }}>
                  {planDowngradeInfo.current_plan} → {planDowngradeInfo.after_plan}
                </div>
                <div
                  className={style.downgradeInfoCancel}
                  data-testid="test-cancel-plan"
                  onClick={() => {
                    if (window.confirm(t("DashboardView.本当に取り消ししますか？"))) {
                      cancelPlanDowngrade();
                    }
                  }}
                >
                  {t("DashboardView.取り消し")}
                </div>
              </div>
            ) : (
              <></>
            )}
            <div className={style.planContent}>
              <DashBoardCurrentPlan
                client={client}
                currentPlan={currentPlan}
                planName={currentPlan.plan_name}
                operationCount={currentPlan.operation_count}
                userLicense={currentPlan.user_license_count}
                membersCount={members_count}
                fetchLicenseDowngradeInfo={fetchLicenseDowngradeInfo}
                getNextPayment={getNextPayment}
                defaultLicenseCount={currentPlan.default_license_count}
                is_internal={is_internal}
              />
              <div style={{ visibility: currentPlan?.is_via_partner ? "hidden" : "visible" }}>
                <div className={style.paymentInfoWrap}>
                  <div className="mb-4">
                    {errMessage && (
                      <div className={style.error}>
                        {errMessage}
                        <div onClick={() => setErrMessage(null)} style={{ cursor: "pointer", marginLeft: "10px" }}>
                          <img
                            src={getImageUrl("images/icons/cancel_error.svg")}
                            style={{ width: "20px", height: "20px" }}
                          />
                        </div>
                      </div>
                    )}
                    <div className="w-100 d-flex justify-content-between">
                      <div className="w-100 d-flex flex-column">
                        <div className={`m-0 ${style.currentTaskRunsLabel}`}>{t("DashboardView.次回請求日")}</div>
                        <div className={style.nextPayDay}>
                          {nextPayment.next_payment_date ? nextPayment.next_payment_date : "-"}
                        </div>
                      </div>
                      <div className="w-100 d-flex flex-column">
                        <div className={`m-0 ${style.currentTaskRunsLabel}`}>{t("DashboardView.現時点での請求額")}</div>
                        <div className={style.nextPayDay}>
                          {nextPayment.currency_symbol.toLocaleString()}
                          {nextPayment.current_charges.toLocaleString()}
                        </div>
                      </div>
                    </div>
                    {isCardDeletable ? (
                      <>
                        {/* カード削除可能な場合 */}
                        <div className={`mt-4 ${style.paymentMethod}`}>{t("DashboardView.支払い方法")}</div>
                        <InfoCard
                          card={card}
                          paymentMethod={currentPaymentMethod}
                          isDelete={true}
                          loading={isDelete}
                          deleteFunc={() => deleteCard()}
                          currentPlan={currentPlan}
                          is_internal={is_internal}
                        />
                      </>
                    ) : (
                      <>
                        <div className={`mt-4 ${style.paymentMethod}`}>{t("DashboardView.支払い方法")}</div>
                        <InfoCard
                          card={card}
                          paymentMethod={currentPaymentMethod}
                          changeFunc={() => handleShow()}
                          currentPlan={currentPlan}
                          is_internal={is_internal}
                        />
                      </>
                    )}
                    <Modal
                      show={show}
                      onHide={handleClose}
                      dialogClassName={style.modalDialogWidth}
                      aria-labelledby="contained-modal-title-vcenter"
                      centered
                      style={{ zIndex: "1501" }}
                    >
                      <div className={style.paymentMethodChangeModalWrap}>
                        {is_internal ? (
                          <>
                            <div className={style.paymentMethodChangeModalTitle}>
                              {t("DashboardView.支払い方法の変更")}
                            </div>
                            <div className={style.paymentMethodChangeModalContent}>
                              {t(
                                "DashboardView.支払い方法の変更が完了すると、次回のお支払い分より変更した方法にてお支払いが行われます。",
                              )}
                            </div>

                            <div style={{ padding: "16px", marginTop: "24px" }}>
                              <div className="d-flex justify-content-between align-items-center">
                                <div
                                  style={{
                                    color: "#222222",
                                    fontSize: "16px",
                                    fontWeight: "700",
                                  }}
                                >
                                  {t("DashboardView.支払い情報")}
                                </div>
                                <select
                                  className={style.paymentMethodChangeModalSelect}
                                  value={paymentOption}
                                  onChange={(e) => setPaymentOption(e.target.value)}
                                >
                                  <option value="credit_card">{t("ChangePlan.クレジットカード払い")}</option>
                                  <option value="send_invoice">{t("ChangePlan.請求書払い")}</option>
                                </select>
                              </div>

                              {paymentOption === "credit_card" && (
                                <>
                                  {!id || (id && isUpdate) ? (
                                    <div>
                                      <div className="d-flex flex-column" style={{ margin: "5px 0px 15px" }}>
                                        <Stripe
                                          client={client}
                                          isUpdate={isUpdate}
                                          register={(token) => registerCard(token)}
                                          update={(token) => updateCard(token)}
                                          setIsUpdate={() => setIsUpdate(false)}
                                          updateAmountPlan={updatePaymentMethod}
                                          setIsLoading={setIsLoading}
                                        />
                                      </div>
                                    </div>
                                  ) : (
                                    <InfoCard
                                      card={card}
                                      changeFunc={() => changeCard()}
                                      styles={{ marginTop: "49px", height: "50px" }}
                                    />
                                  )}
                                </>
                              )}

                              <>
                                {paymanetMethodErrMessage && (
                                  <div className={style.paymentMethodErr}>
                                    <div>{paymanetMethodErrMessage}</div>
                                  </div>
                                )}
                              </>
                            </div>
                            <div className={style.paymentMethodChangeModalButtonWrap}>
                              <SecondaryBtn
                                text={t("DashboardView.キャンセル")}
                                disabled={false}
                                className="test-force-upgrade"
                                submit={() => handleClose()}
                                style={{ color: "#222222", maxWidth: "260px", minWidth: "260px", width: "260px" }}
                              />
                              <InfoBtn
                                text={t("DashboardView.変更する")}
                                loading={isLoading}
                                className="ml-auto test-force-upgrade"
                                submit={() => {
                                  // 請求書払いからクレジットカードへの切り替え時で、かつカード未登録の場合は、updatePaymentMethodを実行しない
                                  if (
                                    currentPaymentMethod === "send_invoice" &&
                                    paymentOption === "credit_card" &&
                                    !id
                                  ) {
                                    return;
                                  }
                                  // 新規カード登録時またはカード更新時は実行しない
                                  if (
                                    (!id && paymentOption === "credit_card") ||
                                    (id && isUpdate && paymentOption === "credit_card")
                                  ) {
                                    return;
                                  }
                                  updatePaymentMethod();
                                }}
                                style={{ maxWidth: "260px", minWidth: "260px", width: "260px" }}
                                stripeFlag={
                                  (!id && paymentOption === "credit_card") ||
                                  (id && isUpdate && paymentOption === "credit_card")
                                    ? true
                                    : false
                                }
                              />
                            </div>
                          </>
                        ) : (
                          <RegistCard
                            code={client}
                            locale={locale}
                            handleClose={handleClose}
                            country_code={country_code}
                            completeMethod={() => {
                              setIsDone(true);
                              getCard();
                              handleClose();
                            }}
                            currentPlan={currentPlan}
                          />
                        )}
                      </div>
                    </Modal>
                    <PaymentCard billing={billing} client={client} />
                  </div>
                </div>
              </div>
            </div>
            {!currentPlan?.is_via_partner && <PaymentHistory payments={payments} client={client} />}
          </div>
        ) : (
          <PageLoader loadingHeight={"50vh"} />
        )}
        <div className={style.isPaymentModalWrap} style={{ display: isDone ? "block" : "none" }}>
          <div className={`d-flex flex-column ${style.isPaymentModal} test-done-notice`}>
            <div className="d-flex align-items-center">
              <span>{t("DashboardView.支払い方法の変更が完了しました。")}</span>
            </div>
          </div>
        </div>
        <div className={style.isPaymentModalWrap} style={{ display: isPlanCancelDone ? "block" : "none" }}>
          <div className={`d-flex flex-column ${style.isPaymentModal} test-done-notice`}>
            <div className="d-flex align-items-center">
              <span>{t("DashboardView.ダウングレード取り消しが完了しました。")}</span>
            </div>
          </div>
        </div>
        <div className={style.isPaymentModalWrap} style={{ display: isLicenseCancelDone ? "block" : "none" }}>
          <div className={`d-flex flex-column ${style.isPaymentModal} test-done-notice`}>
            <div className="d-flex align-items-center">
              <span>{t("DashboardView.ライセンスの削除予約を取り消しました。")}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

DashboardView.propTypes = {
  client: PropTypes.string,
  members_count: PropTypes.number,
  client_id: PropTypes.number,
  is_internal: PropTypes.bool,
  locale: PropTypes.string,
  country_code: PropTypes.string,
};
